<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Medio Com Imagen</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Imagen</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">Medio de Comunicación</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mediocomimg in datosPaginados" :key="mediocomimg.idMedioComImg">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(mediocomimg.idMedioComImg)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(mediocomimg.idMedioComImg)" title="Editar">edit_square</i></td>
          <td><img :src="direccionImagen(mediocomimg.idMedioComImg)" :style="estiloImagen"/></td>
          <td>{{mediocomimg.nombre}}</td>
          <td>{{mediocomimg.tipo}}</td>
          <td>{{mediocomimg.medioComNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedioComImg(mediocomimg.idMedioComImg)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedioComImg" class="form-label">IdMedioComImg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedioComImg" name="idMedioComImg" v-model="datoMedioComImg.idMedioComImg" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label"> Medio Com</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoMedioComImg.idMedioCom">
                      <option v-for="medioCom in medioComs" :value="medioCom.idMedioCom" :key="medioCom.idMedioCom">
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen" name="imagen" v-model="datoMedioComImg.imagen" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                  <img :src="direccionImagen(datoMedioComImg.idMedioComImg)" :style="estiloImagen"/>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                <input type="file" class="form-control" id="imagenCarga" name="imagenCarga" accept="image/*" @change="handleFileUpload">
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoMedioComImg.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tipo" name="tipo" v-model="datoMedioComImg.tipo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedioComImg" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioComImg" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      mediocomimgs : [],
      datoMedioComImg : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      medioComs: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchMedioComs()
  },
  methods : {
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("image", file);
      await api.post('/mediocomimgs/'+this.datoMedioComImg.idMedioCom, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        // Manejar la respuesta del backend
        console.log("Archivo subido exitosamente"+response);
      })
      .catch(error => {
        // Manejar errores
        console.error("Error al subir el archivo", error.response.data);
      });
    },
    totalPaginas(){
      return Math.ceil(this.mediocomimgs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmediocomimgs/nombre/'+this.nombreBusqueda).then(response=>{
          this.mediocomimgs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.mediocomimgs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmediocomimgs').then(response=>{
      this.mediocomimgs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.mediocomimgs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idMedioCom'
        ,'imagen'
        ,'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'idMedioCom'
        ,'imagen'
        ,'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoMedioComImg, requiredFields, requiredFieldsText);
    },
    async guardarMedioComImg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocomimgs', this.datoMedioComImg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "MedioComImg creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioComImg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/mediocomimgs', this.datoMedioComImg)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "MedioComImg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedioComImg={}
      this.titulo   = 'Crear Medio Com Imagen'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idMedioComImg){
      this.modalWindow = true
      if(idMedioComImg != null){    
           api.get('/vwmediocomimgs/'+idMedioComImg).then(resp=>{
          this.datoMedioComImg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Medio Com Imagen'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idMedioComImg){
      if(idMedioComImg != null){
        this.$router.push('/mediocomimgmd/'+idMedioComImg)
      }
    },
    async deleteMedioComImg (idMedioComImg) {
      try{
        await api.delete('/mediocomimgs/'+idMedioComImg)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchMedioComs() {
      fetch('http://localhost:8080/api/v1/mediocoms')
        .then(response => response.json())
        .then(data => {
          this.medioComs = data;
        })
        .catch(error => {
          console.error('Error fetching medioComs:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
